export default "/fonts/vendor/@fontsource/space-grotesk/files/space-grotesk-latin-400-normal.woff2?d66206ff9ff7c6f0e942fe590083b281";